import React, { Component } from 'react';
import ListSchedule from './ListSchedule'
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import styles from '../../styles/schedule.module.css';
import { isAuthenticated } from '../../actions/authentication';
import { getDescriptionHoursPayables } from '../../actions/schedule/scheduler';
import { withCookies } from 'react-cookie';
import { RenewToken } from '../../utils/token';
import { ChatContext } from '@/ChatProvider';

export class Schedule extends Component {

    constructor(props) {
        super(props);

        this.state = {
            authenticated: false,
            descriptionTotalPayables : ''
        }
    }

    componentDidMount() {
        this.loadPage();
    }

    async loadPage() {
        this.handleTitle();

        await this.handleToken();

        this.getDescriptionTotalPayables();
    }

    handleToken() {
        return new Promise(async (resolve) => {
            await RenewToken(this.props);

            isAuthenticated().then((result) => {
                this.setState({ authenticated: result }, () => {
                    resolve();
                });
                this.context.setIsAuthenticated(result);
            });
        })
    }

    handleTitle() {
        this.props.onLoadTitle(i18next.t('menu:schedule'));
    }

    getDescriptionTotalPayables() {
        getDescriptionHoursPayables().then((response) => {
            const result = JSON.parse(response.result);

            this.setState({ descriptionTotalPayables: result.descriptionTotalPayables })
        });
    }

    render() {
        return (
            this.state.authenticated && <div className={styles.rootSchedule}>
                <ListSchedule descriptionTotalHoursPayables={this.state.descriptionTotalPayables} />
            </div>
        );
    }
}

Schedule.contextType = ChatContext;
export default withNamespaces(['menu'], { wait: true })(withCookies(Schedule));